import { cx } from "@linaria/core";

import * as styles from "./atom.chevrons.style";
import { CircularButton } from "@pm2/compat";

type Props = {
  onPrevClick(): void;
  onNextClick(): void;
};

export function Chevrons(props: Props): React.JSX.Element {
  return (
    <>
      <div className={cx(styles.button, "prev")}>
        <CircularButton
          inversed
          aria-label={"Gå til forrige slide"}
          onClick={props.onPrevClick}
        />
      </div>

      <div className={cx(styles.button, "next")}>
        <CircularButton
          aria-label={"Gå til næste slide"}
          onClick={props.onNextClick}
        />
      </div>
    </>
  );
}
